var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetbanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_x3C_Path_x3E__00000168819907245115916440000003953637181157672098_",
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M282.668,380.992H148.224c-36.239,0-68.774-23.682-80.37-59.244 c-0.262-0.803-0.52-1.617-0.775-2.442c-10.035-32.478-15.484-70.322,17.867-120.904c33.351-50.583,10.473-98.028,53.353-115.3 c42.88-17.272,77.668,4.265,126.503-16.708s146.506-19.739,152.461,65.387c5.956,85.127-17.867,81.425-8.338,109.801 C418.454,269.958,450.614,388.395,282.668,380.992z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E4F1FF"
    },
    cx: 156.979,
    cy: 428.538,
    rx: 90.519,
    ry: 24.183
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1C004F",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 65.36,
    y1: 380.934,
    x2: 433.937,
    y2: 380.934
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCCFB"
    },
    d: "M114.842,437.7l75.347,0.081c2.424,0.003,4.392-1.961,4.394-4.385l0.081-74.495l-79.737-0.085 L114.842,437.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCCFB"
    },
    d: "M114.928,358.813l79.699,0.085l-25.094-19.997c-1.739-1.386-3.905-2.143-6.139-2.146l-66.725-0.071 c-1.66-0.002-2.485,1.992-1.3,3.142L114.928,358.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCCFB"
    },
    d: "M92.516,411.637l-0.249-68.544c0.006-5.222,3.396-6.077,3.396-6.077l-0.615,1.288 c-0.301,0.663,0.328,1.437,0.851,1.947l19.038,18.565l-0.086,78.879l-19.885-20.137C93.403,415.974,92.524,413.851,92.516,411.637 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M137.106,358.839l-18.852-0.02 c-1.837-0.002-3.328,1.486-3.33,3.323l-0.022,19.907"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 114.889,
    y1: 394.64,
    x2: 114.846,
    y2: 434.373
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 103.156,
    y1: 347.436,
    x2: 114.826,
    y2: 358.815
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M95.552,337.016l-0.615,1.288 c-0.301,0.663,0.328,1.437,0.851,1.947l5.322,5.19"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M301.236,381.328H196.66c-9.359,0-16.946-7.587-16.946-16.946V134.936 c0-9.359,7.587-16.946,16.946-16.946h104.576c9.359,0,16.946,7.587,16.946,16.946v229.446 C318.182,373.741,310.595,381.328,301.236,381.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M302.236,374.801H195.659c-5.491,0-9.943-4.452-9.943-9.943V134.46 c0-5.491,4.452-9.943,9.943-9.943h106.577c5.491,0,9.943,4.452,9.943,9.943v230.397 C312.179,370.349,307.728,374.801,302.236,374.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M269.974,139.58h-42.052c-5.195,0-9.406-4.211-9.406-9.406v-8.418c0-0.276,0.223-0.499,0.499-0.499 h60.366v8.917C279.38,135.369,275.169,139.58,269.974,139.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4D8F9"
    },
    d: "M217.162,109.457c0.096,16.63-13.307,30.189-29.937,30.285 c-16.63,0.096-30.189-13.308-30.284-29.937c-0.096-16.631,13.307-30.189,29.937-30.285 C203.507,79.424,217.066,92.827,217.162,109.457z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71B7E2"
    },
    d: "M209.462,109.025c0.073,12.643-10.116,22.95-22.758,23.022 c-12.643,0.073-22.95-10.116-23.023-22.758c-0.073-12.643,10.116-22.95,22.758-23.023 C199.082,86.194,209.389,96.382,209.462,109.025z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF725E"
    },
    d: "M210.114,109.975c0.072,12.472-9.98,22.642-22.453,22.713 c-12.473,0.072-22.641-9.98-22.713-22.453c-0.072-12.473,9.98-22.642,22.453-22.714 C199.873,87.45,210.042,97.503,210.114,109.975z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC2F2"
    },
    d: "M210.114,109.975c0.072,12.472-9.98,22.642-22.453,22.713 c-12.473,0.072-22.641-9.98-22.713-22.453c-0.072-12.473,9.98-22.642,22.453-22.714 C199.873,87.45,210.042,97.503,210.114,109.975z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71B7E2"
    },
    d: "M188.419,108.143l-0.033-5.778c0.009,0,0.019,0,0.028,0 c1.004,0.11,2.045,0.372,3.076,0.783c0.861,0.44,1.444,0.899,1.444,0.899l0.075-0.179l0.879-2.085l0.202-0.479 l-1.036-1.076l-0.494,0.226c-1.266-0.625-2.708-1.112-4.192-1.184l-0.018-3.178l-0.994-0.791l0.005,0.797l-1.358,0.008 l0.019,3.235c-4.463,0.455-6.567,3.015-6.55,5.935c0.023,3.979,3.436,4.99,6.617,5.744l0.033,5.725 c-2.177-0.188-4.329-1.006-5.738-2.143l-1.271,2.899c1.496,1.28,4.221,2.18,7.027,2.336l0.014,2.399l-1.117,0.026 l1.122,0.752l2.347-0.014l-0.019-3.206c4.491-0.484,6.624-3.015,6.607-5.935 C195.07,109.879,191.601,108.897,188.419,108.143z M186.068,107.555c-1.663-0.477-2.898-1.1-2.906-2.474 c-0.007-1.259,0.846-2.295,2.876-2.621L186.068,107.555z M188.386,102.36L188.386,102.36L188.386,102.36 C188.386,102.36,188.386,102.36,188.386,102.36z M188.468,116.673l-0.029-5.067c1.72,0.477,2.983,1.128,2.992,2.53 C191.438,115.368,190.556,116.346,188.468,116.673z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.511,119.014l0.019,3.207l-2.348,0.013l-0.018-3.178 c-2.807-0.156-5.532-1.056-7.028-2.336l1.272-2.898c1.41,1.137,3.561,1.954,5.739,2.142l-0.033-5.726 c-3.182-0.754-6.595-1.766-6.618-5.745c-0.017-2.921,2.087-5.481,6.551-5.936l-0.019-3.235l2.348-0.014l0.018,3.178 c2.12,0.102,4.27,0.72,5.823,1.713l-1.158,2.898c-1.522-0.879-3.129-1.356-4.647-1.519l0.033,5.783 c3.183,0.755,6.653,1.737,6.676,5.716C194.136,115.998,192.003,118.53,187.511,119.014z M185.092,106.774l-0.029-5.096 c-2.031,0.327-2.884,1.362-2.876,2.622C182.194,105.674,183.429,106.297,185.092,106.774z M190.456,113.357 c-0.008-1.403-1.272-2.054-2.992-2.531l0.029,5.068C189.581,115.567,190.463,114.588,190.456,113.357z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4D8F9"
    },
    d: "M268.654,81.53c0.061,10.536-8.431,19.126-18.966,19.187 c-10.536,0.061-19.126-8.431-19.187-18.967c-0.061-10.536,8.43-19.126,18.967-19.187 C260.003,62.503,268.593,70.994,268.654,81.53z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71B7E2"
    },
    d: "M263.776,81.257c0.046,8.01-6.409,14.54-14.418,14.586 c-8.01,0.046-14.54-6.409-14.586-14.419c-0.046-8.01,6.409-14.54,14.419-14.586 C257.199,66.792,263.729,73.247,263.776,81.257z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF725E"
    },
    d: "M264.188,81.858c0.046,7.902-6.323,14.345-14.225,14.39 c-7.902,0.046-14.344-6.323-14.39-14.225c-0.046-7.902,6.323-14.344,14.225-14.39 C257.701,67.588,264.143,73.956,264.188,81.858z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC2F2"
    },
    d: "M264.188,81.858c0.046,7.902-6.323,14.345-14.225,14.39 c-7.902,0.046-14.344-6.323-14.39-14.225c-0.046-7.902,6.323-14.344,14.225-14.39 C257.701,67.588,264.143,73.956,264.188,81.858z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71B7E2"
    },
    d: "M250.444,80.697l-0.021-3.66c0.006,0,0.012,0,0.018,0c0.636,0.07,1.296,0.236,1.949,0.496 c0.546,0.279,0.915,0.57,0.915,0.57l0.048-0.113l0.557-1.321l0.128-0.304l-0.656-0.682l-0.313,0.143 c-0.802-0.396-1.716-0.705-2.656-0.75l-0.011-2.013l-0.63-0.501l0.003,0.505l-0.86,0.005l0.012,2.049 c-2.828,0.288-4.161,1.91-4.15,3.76c0.015,2.521,2.176,3.161,4.192,3.64l0.021,3.627 c-1.379-0.119-2.742-0.637-3.635-1.357l-0.805,1.836c0.948,0.811,2.674,1.381,4.452,1.48l0.009,1.52l-0.708,0.016 l0.711,0.477l1.487-0.008l-0.012-2.031c2.846-0.306,4.197-1.91,4.186-3.76C254.658,81.797,252.46,81.175,250.444,80.697z  M248.955,80.325c-1.054-0.302-1.836-0.697-1.841-1.567c-0.005-0.798,0.536-1.454,1.822-1.661L248.955,80.325z  M250.423,77.034L250.423,77.034L250.423,77.034C250.423,77.034,250.423,77.034,250.423,77.034z M250.475,86.102 l-0.018-3.21c1.09,0.302,1.89,0.715,1.895,1.603C252.356,85.275,251.798,85.895,250.475,86.102z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.868,87.585l0.012,2.032l-1.487,0.008l-0.012-2.013 c-1.778-0.099-3.505-0.669-4.453-1.48l0.806-1.836c0.893,0.72,2.256,1.238,3.636,1.357l-0.021-3.628 c-2.016-0.478-4.178-1.119-4.193-3.64c-0.011-1.85,1.322-3.473,4.15-3.761l-0.012-2.05l1.487-0.009l0.011,2.013 c1.343,0.065,2.705,0.456,3.689,1.085l-0.733,1.836c-0.964-0.557-1.982-0.859-2.944-0.963l0.021,3.664 c2.016,0.478,4.215,1.1,4.229,3.622C254.066,85.674,252.715,87.278,249.868,87.585z M248.336,79.83l-0.019-3.229 c-1.286,0.207-1.827,0.863-1.822,1.661C246.5,79.133,247.283,79.528,248.336,79.83z M251.734,84.001 c-0.005-0.889-0.806-1.301-1.896-1.603l0.018,3.211C251.18,85.401,251.739,84.781,251.734,84.001z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCCFB"
    },
    d: "M390.628,267.248h45.919c2.241,0,4.059-1.817,4.059-4.059v-47.434 c0-2.241-1.817-4.059-4.059-4.059h-45.919c-2.242,0-4.059,1.817-4.059,4.059v47.434 C386.569,265.431,388.386,267.248,390.628,267.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E6CFC"
    },
    d: "M436.546,211.697h-45.919c-2.242,0-4.059,1.817-4.059,4.059v11.937h54.036v-11.937 C440.605,213.514,438.788,211.697,436.546,211.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M425.728,241.557h7.22c0.435,0,0.787-0.352,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C424.94,241.205,425.293,241.557,425.728,241.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M415.414,241.557h7.22c0.435,0,0.787-0.352,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C414.627,241.205,414.979,241.557,415.414,241.557z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC3F4"
    },
    d: "M400.732,215.854c-0.994,0-1.801-0.806-1.801-1.801v-6.377c0-0.995,0.807-1.801,1.801-1.801 c0.994,0,1.801,0.806,1.801,1.801v6.377C402.533,215.048,401.727,215.854,400.732,215.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC3F4"
    },
    d: "M409.849,215.864c-0.994,0-1.801-0.806-1.801-1.801v-6.377c0-0.995,0.807-1.801,1.801-1.801 c0.994,0,1.801,0.806,1.801,1.801v6.377C411.65,215.058,410.843,215.864,409.849,215.864z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC3F4"
    },
    d: "M418.542,215.857c-0.994,0-1.801-0.806-1.801-1.801v-6.377c0-0.995,0.807-1.801,1.801-1.801 c0.994,0,1.801,0.806,1.801,1.801v6.377C420.343,215.051,419.537,215.857,418.542,215.857z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M405.028,241.557h7.22c0.435,0,0.787-0.352,0.787-0.787v-7.22c0-0.435-0.352-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C404.241,241.205,404.593,241.557,405.028,241.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M394.714,241.557h7.22c0.435,0,0.787-0.352,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C393.927,241.205,394.28,241.557,394.714,241.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M425.653,251.348h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.352-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C424.866,250.995,425.218,251.348,425.653,251.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M415.339,251.348h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C414.552,250.995,414.905,251.348,415.339,251.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M404.954,251.348h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C404.166,250.995,404.519,251.348,404.954,251.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M394.64,251.348h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C393.853,250.995,394.205,251.348,394.64,251.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M425.58,261.221h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C424.793,260.868,425.145,261.221,425.58,261.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M415.266,261.221h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C414.479,260.868,414.832,261.221,415.266,261.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M404.881,261.221h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C404.093,260.868,404.446,261.221,404.881,261.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4F1FF"
    },
    d: "M394.567,261.221h7.22c0.435,0,0.787-0.353,0.787-0.787v-7.22c0-0.435-0.353-0.787-0.787-0.787 h-7.22c-0.435,0-0.787,0.353-0.787,0.787v7.22C393.78,260.868,394.132,261.221,394.567,261.221z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC3F4"
    },
    d: "M427.256,215.857c-0.994,0-1.801-0.806-1.801-1.801v-6.377c0-0.995,0.807-1.801,1.801-1.801 c0.994,0,1.801,0.806,1.801,1.801v6.377C429.057,215.051,428.25,215.857,427.256,215.857z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#9FCCFB"
    },
    d: "M350.759,172.493H219.027c-4.28,0-7.75,3.47-7.75,7.75v1.21v67.344 c0,4.28,3.47,7.749,7.75,7.749h131.731c4.28,0,7.75-3.469,7.75-7.749V236.64v-56.397 C358.508,175.963,355.038,172.493,350.759,172.493z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCCFB"
    },
    d: "M347.348,253.854H215.617c-4.28,0-7.75-3.47-7.75-7.75v-68.554c0-4.28,3.47-7.75,7.75-7.75 h131.731c4.28,0,7.75,3.47,7.75,7.75v68.554C355.098,250.385,351.628,253.854,347.348,253.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC3F4"
    },
    d: "M355.098,177.551c0-4.28-3.47-7.75-7.75-7.75H215.617c-4.28,0-7.75,3.47-7.75,7.75v1.21 c16.122,0.732,47.372,6.017,69.169,34c25.088,32.207,58.802,29.058,78.061,21.186V177.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.311,216.665h-18.389c-1.629,0-2.95-1.321-2.95-2.95v-9.629c0-1.629,1.321-2.95,2.95-2.95 h18.389c1.629,0,2.95,1.321,2.95,2.95v9.629C244.261,215.344,242.941,216.665,241.311,216.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M344.975,184.811h-26.627c-0.674,0-1.22-0.546-1.22-1.22v-5.125c0-0.674,0.546-1.22,1.22-1.22 h26.627c0.674,0,1.22,0.546,1.22,1.22v5.125C346.195,184.264,345.649,184.811,344.975,184.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M244.46,229.786h-22.786c-1.424,0-2.579-1.155-2.579-2.579l0,0c0-1.424,1.155-2.579,2.579-2.579 h22.786c1.424,0,2.579,1.154,2.579,2.579l0,0C247.039,228.631,245.884,229.786,244.46,229.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.72,229.786h-22.786c-1.424,0-2.579-1.155-2.579-2.579l0,0c0-1.424,1.155-2.579,2.579-2.579 h22.786c1.424,0,2.579,1.154,2.579,2.579l0,0C279.298,228.631,278.144,229.786,276.72,229.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.221,229.786h-22.786c-1.424,0-2.579-1.155-2.579-2.579l0,0c0-1.424,1.155-2.579,2.579-2.579 h22.786c1.424,0,2.579,1.154,2.579,2.579l0,0C311.799,228.631,310.645,229.786,309.221,229.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.48,229.786h-22.786c-1.424,0-2.579-1.155-2.579-2.579l0,0c0-1.424,1.154-2.579,2.579-2.579 h22.786c1.424,0,2.579,1.154,2.579,2.579l0,0C344.059,228.631,342.905,229.786,341.48,229.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M251.657,247.179h-29.64c-0.866,0-1.567-0.702-1.567-1.567l0,0c0-0.866,0.702-1.568,1.567-1.568 h29.64c0.866,0,1.568,0.702,1.568,1.568l0,0C253.225,246.477,252.523,247.179,251.657,247.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M341.4,247.179h-14.625c-0.866,0-1.567-0.702-1.567-1.567l0,0c0-0.866,0.702-1.568,1.567-1.568 H341.4c0.866,0,1.567,0.702,1.567,1.568l0,0C342.967,246.477,342.266,247.179,341.4,247.179z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M241.311,216.665h-18.389c-1.629,0-2.95-1.321-2.95-2.95v-9.629c0-1.629,1.321-2.95,2.95-2.95h18.389 c1.629,0,2.95,1.321,2.95,2.95v9.629C244.261,215.344,242.941,216.665,241.311,216.665z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063612330158697303340000002542032842465045135_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000063612330158697303340000002542032842465045135_)",
      fill: "none",
      stroke: "#8EC3F4",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M224.404,200.869c2.152,2.765,5.562,9.04-0.288,16.204"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000063612330158697303340000002542032842465045135_)",
      fill: "none",
      stroke: "#8EC3F4",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 218.408,
    y1: 208.759,
    x2: 227.319,
    y2: 208.759
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000063612330158697303340000002542032842465045135_)",
      fill: "none",
      stroke: "#8EC3F4",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M239.159,200.869c-2.152,2.765-5.562,9.04,0.288,16.204"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000063612330158697303340000002542032842465045135_)",
      fill: "none",
      stroke: "#8EC3F4",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 245.155,
    y1: 208.759,
    x2: 236.243,
    y2: 208.759
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.58,115.131c-6.599-6.92-7.082-9.335,3.219-19.474c10.3-10.139,8.691-24.141,8.691-24.141 l-19.787-0.381v-0.022l-0.568,0.011l-0.568-0.011v0.022l-19.787,0.381c0,0-1.609,14.002,8.691,24.141 c10.3,10.139,9.818,12.553,3.219,19.474c-6.598,6.921-15.611,13.68-15.289,26.394h23.167h1.135h23.167 C387.191,128.811,378.178,122.051,371.58,115.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E6CFC"
    },
    d: "M387.261,144.971h-48.254c-1.467,0-2.655-1.189-2.655-2.656l0,0c0-1.467,1.189-2.656,2.655-2.656 h48.254c1.467,0,2.655,1.189,2.655,2.656l0,0C389.917,143.783,388.728,144.971,387.261,144.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E6CFC"
    },
    d: "M387.261,73.688h-48.254c-1.467,0-2.655-1.189-2.655-2.656l0,0c0-1.467,1.189-2.656,2.655-2.656 h48.254c1.467,0,2.655,1.189,2.655,2.656l0,0C389.917,72.499,388.728,73.688,387.261,73.688z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCCFB"
    },
    d: "M353.966,92.008h18.726c0.631,0,0.974,0.698,0.568,1.156l-8.515,9.608 c-0.112,0.127-0.174,0.287-0.174,0.453v29.062c0,0.389,0.332,0.704,0.742,0.704h15.915c0.324,0,0.61,0.199,0.708,0.492 l1.066,3.199c0.151,0.454-0.206,0.916-0.708,0.916h-38.298c-0.486,0-0.841-0.436-0.718-0.882l0.889-3.222 c0.085-0.309,0.379-0.525,0.715-0.526l16.436-0.057c0.409-0.001,0.74-0.316,0.74-0.704V103.38c0-0.163-0.06-0.322-0.169-0.448 l-8.496-9.773C352.995,92.7,353.339,92.008,353.966,92.008z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__00000129189239097836037190000007050095679799202437_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000127004766677986551730000003523047634743146890_",
    style: {
      fill: "#4E6CFC"
    },
    d: "M358.682,343.189 c0,0,0.17-22.001,13.771-23.576c13.6-1.575,18.286,2.464,20.149,3.211c1.862,0.746-3.042,1.749-7.191,5.807 c-4.148,4.059-4.106,9.119-13.46,10.775c-9.354,1.656-12.835,8.546-12.835,8.546L358.682,343.189z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000111154163654685330060000017324678429827178412_",
    style: {
      fill: "none",
      stroke: "#1A2E9D",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M359.115,347.952c0,0,4.361-22.57,25.443-23.488"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__00000057841454533619677480000010332105292027553204_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000023249338477839663100000012025947548543048616_",
    style: {
      fill: "#4E6CFC"
    },
    d: "M359.798,335.371 c0,0,2.036-18.97-9.524-21.675c-11.56-2.706-15.997,0.309-17.675,0.767c-1.678,0.458,2.447,1.808,5.618,5.716 c3.171,3.908,2.632,8.263,10.526,10.617c7.893,2.354,10.209,8.635,10.209,8.635L359.798,335.371z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000169522446785322816250000014805843895233261489_",
    style: {
      fill: "none",
      stroke: "#1A2E9D",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M358.953,339.431c0,0-1.518-19.875-19.588-22.757"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M361.058,292.026c0.005-0.001,0.022,0.073,0.05,0.218c0.029,0.161,0.068,0.375,0.117,0.646 c0.05,0.291,0.11,0.642,0.18,1.054c0.052,0.422,0.111,0.906,0.177,1.448c0.238,2.18,0.418,5.365,0.195,9.286 c-0.186,3.923-0.771,8.563-1.425,13.702c-0.662,5.138-1.228,10.809-1.321,16.785c-0.266,11.963,1.193,22.754,2.759,30.419 c0.76,3.844,1.584,6.908,2.128,9.03c0.291,1.042,0.52,1.857,0.68,2.43c0.071,0.267,0.127,0.477,0.169,0.634 c0.036,0.143,0.053,0.218,0.048,0.219c0,0-1.62-4.587-3.239-12.269c-1.624-7.666-3.121-18.478-2.855-30.469 c0.093-5.988,0.67-11.677,1.348-16.815c0.67-5.14,1.276-9.767,1.489-13.678c0.25-3.909,0.104-7.083-0.097-9.261 c-0.055-0.542-0.105-1.025-0.148-1.448c-0.059-0.413-0.109-0.765-0.151-1.056c-0.036-0.273-0.065-0.489-0.087-0.651 C361.06,292.103,361.053,292.027,361.058,292.026z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21212A"
    },
    d: "M373.907,357.879h-26.063c-0.623,0-1.127-0.505-1.127-1.127v-3.135 c0-0.623,0.505-1.127,1.127-1.127h26.063c0.623,0,1.127,0.505,1.127,1.127v3.135C375.035,357.374,374.53,357.879,373.907,357.879 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21212A"
    },
    d: "M368.071,380.654h-13.429c-1.084,0-2.011-0.78-2.195-1.849l-3.763-21.794h24.384l-2.788,21.699 C370.138,379.821,369.191,380.654,368.071,380.654z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__00000115516425068506358190000013653754119552492980_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000147186917931563912930000002552327294493076893_",
    style: {
      fill: "#4E6CFC"
    },
    d: "M360.743,312.238 c0,0,1.848-14.408,10.887-14.367c9.039,0.041,11.792,3.059,12.954,3.695c1.162,0.636-2.132,0.906-5.172,3.239 c-3.04,2.333-3.411,5.654-9.673,6c-6.262,0.347-9.088,4.589-9.088,4.589L360.743,312.238z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000035504799823082130360000001693996610431302034_",
    style: {
      fill: "none",
      stroke: "#1A2E9D",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M360.651,315.394c0,0,4.64-14.45,18.532-13.388"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__00000059307280953920876490000003870961844426934919_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000167366550571504357660000007572623739909767103_",
    style: {
      fill: "#4E6CFC"
    },
    d: "M362.534,301.351 c0,0,3.355-14.134-5.117-17.285c-8.472-3.151-12.113-1.299-13.424-1.114c-1.312,0.185,1.675,1.6,3.696,4.856 c2.021,3.256,1.197,6.494,6.934,9.028c5.737,2.534,6.884,7.501,6.884,7.501L362.534,301.351z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__00000167355882994394677020000015208752568880680116_",
    style: {
      fill: "none",
      stroke: "#1A2E9D",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M361.506,304.336c0,0,0.758-15.158-12.615-19.066"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E6CFC"
    },
    d: "M144.737,145.226c0-1.851-1.5-3.351-3.351-3.351H91.931c-1.851,0-3.351,1.5-3.351,3.351v26.724 c0,1.851,1.5,3.351,3.351,3.351h40.759l3.836,5.228c1.195,1.629,3.262,1.478,4.208-0.307l3.316-6.26 c0.425-0.562,0.687-1.254,0.687-2.013V145.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M135.349,153.85H97.501c-0.591,0-1.07-0.479-1.07-1.07l0,0c0-0.591,0.479-1.07,1.07-1.07h37.848 c0.591,0,1.07,0.479,1.07,1.07l0,0C136.419,153.37,135.94,153.85,135.349,153.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M123.846,158.862H97.501c-0.591,0-1.07-0.479-1.07-1.07l0,0c0-0.591,0.479-1.07,1.07-1.07h26.345 c0.591,0,1.07,0.479,1.07,1.07l0,0C124.916,158.383,124.437,158.862,123.846,158.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M130.237,163.98H97.501c-0.591,0-1.07-0.479-1.07-1.07l0,0c0-0.591,0.479-1.07,1.07-1.07h32.736 c0.591,0,1.07,0.479,1.07,1.07l0,0C131.308,163.501,130.828,163.98,130.237,163.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCCFB"
    },
    d: "M282.635,317.841c0.094,16.334-13.071,29.652-29.405,29.747 c-16.335,0.094-29.652-13.071-29.746-29.406c-0.094-16.335,13.07-29.652,29.405-29.747 C269.223,288.342,282.541,301.507,282.635,317.841z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0553 -0.9985 0.9985 0.0553 -78.7517 548.6348)",
    style: {
      fill: "#B4D8F9"
    },
    cx: 250.558,
    cy: 315.935,
    rx: 29.875,
    ry: 29.875
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71B7E2"
    },
    d: "M272.793,315.334c0.072,12.544-10.036,22.77-22.58,22.842 c-12.544,0.072-22.77-10.036-22.842-22.58c-0.072-12.544,10.036-22.77,22.58-22.842 C262.495,292.681,272.721,302.79,272.793,315.334z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF725E"
    },
    d: "M273.44,316.276c0.071,12.375-9.902,22.464-22.277,22.535 c-12.375,0.071-22.464-9.902-22.535-22.277c-0.071-12.375,9.902-22.464,22.277-22.535 C263.28,293.928,273.368,303.901,273.44,316.276z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC2F2"
    },
    d: "M273.44,316.276c0.071,12.375-9.902,22.464-22.277,22.535 c-12.375,0.071-22.464-9.902-22.535-22.277c-0.071-12.375,9.902-22.464,22.277-22.535 C263.28,293.928,273.368,303.901,273.44,316.276z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71B7E2"
    },
    d: "M251.915,314.458l-0.033-5.732c0.009-0.001,0.018,0,0.028,0 c0.996,0.109,2.029,0.369,3.051,0.777c0.854,0.436,1.432,0.892,1.432,0.892l0.075-0.178l0.872-2.069l0.201-0.475 l-1.028-1.067l-0.49,0.224c-1.257-0.62-2.687-1.104-4.159-1.175l-0.018-3.153l-0.986-0.785l0.005,0.791l-1.347,0.008 l0.019,3.209c-4.428,0.451-6.515,2.991-6.499,5.888c0.023,3.948,3.408,4.951,6.565,5.699l0.033,5.68 c-2.16-0.186-4.295-0.998-5.693-2.126l-1.261,2.876c1.484,1.27,4.188,2.163,6.972,2.317l0.014,2.38l-1.109,0.026 l1.113,0.746l2.329-0.013l-0.018-3.181c4.456-0.48,6.572-2.992,6.555-5.889 C258.514,316.181,255.072,315.206,251.915,314.458z M249.583,313.875c-1.65-0.473-2.875-1.091-2.883-2.454 c-0.007-1.249,0.839-2.277,2.854-2.601L249.583,313.875z M251.883,308.721L251.883,308.721L251.883,308.721 C251.882,308.721,251.882,308.721,251.883,308.721z M251.964,322.922l-0.029-5.027c1.707,0.473,2.96,1.119,2.968,2.51 C254.911,321.626,254.035,322.597,251.964,322.922z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.014,325.244l0.018,3.182l-2.329,0.013l-0.018-3.153 c-2.785-0.155-5.489-1.048-6.973-2.318l1.262-2.876c1.398,1.128,3.533,1.939,5.694,2.126l-0.033-5.681 c-3.157-0.749-6.543-1.752-6.566-5.7c-0.017-2.898,2.071-5.438,6.499-5.889l-0.019-3.21l2.329-0.014l0.018,3.153 c2.103,0.102,4.237,0.714,5.777,1.7l-1.148,2.875c-1.51-0.872-3.104-1.345-4.611-1.507l0.033,5.738 c3.157,0.749,6.6,1.723,6.623,5.672C257.588,322.252,255.471,324.764,251.014,325.244z M248.615,313.1l-0.029-5.056 c-2.015,0.324-2.861,1.352-2.854,2.602C245.74,312.009,246.965,312.627,248.615,313.1z M253.936,319.631 c-0.008-1.392-1.262-2.038-2.969-2.511l0.029,5.028C253.069,321.824,253.944,320.853,253.936,319.631z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E4F1FF"
    },
    cx: 273.193,
    cy: 294.486,
    r: 12.17
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#4E6CFC",
      strokeWidth: 1.5236,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M269.081,294.227 l1.633,3.663c0.165,0.371,0.657,0.452,0.932,0.153l6.103-6.633"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 273.159,
    cy: 294.452,
    r: 10.088
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE001D"
    },
    d: "M112.379,201.061c0,0,3.689-10.212,19.244-5.793c10.369,2.945,16.396,11.174,15.71,23.261 c-0.724,12.768,7.347,8.849,2.648,27.301c-3.177,12.476,11.917,22.755-1.814,42.35c-11.118,15.866-73.996,6.727-73.364-20.649 c0.298-12.928,11.094-6.883,11.745-27.734c0.276-8.851,17.136-5.898,14.868-19.321 C100.286,213.79,105.639,200.212,112.379,201.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B70825",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M131.421,240.791 c0,0,4.276,2.625,3.214,8.351c-1.062,5.726-1.533,11.129,3.359,15.309"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B70825",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M142.858,227.47 c1.051,4.604,3.039,7.681,0.294,13.93c-5.795,13.193,5.784,15.941,0.226,28.022c-1.993,4.331-2.797,8.071-3.208,11.333"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7C2A0"
    },
    points: "145.329,292.725 165.188,292.728 159.1,286.082 146.071,288.052  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B70825",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M109.242,234.882 c0,0-5.689,3.156-4.926,9.144c1.029,8.077-7.008,9.338-5.008,14.392"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B70825",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M106.686,213.286 c0,0-2.302,5.027-1.699,10.096c1.235,10.39-12.871,10.612-12.977,21.098c-0.066,6.554-5.535,10.557-9.086,14.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x3C_Path_x3E__00000020362313313429574110000009973829366033665680_",
    style: {
      fill: "#E8977B"
    },
    points: "203.65,411.869  203.61,423.983 192.431,424.072 190.661,414.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_x3C_Path_x3E__00000137118393383351872080000006894182123488554369_",
    style: {
      fill: "#E8977B"
    },
    points: " 170.241,415.666 169.147,428.882 157.064,429.977 155.088,420.038  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556BFF"
    },
    d: "M120.367,326.228c12.846,6.897,39.592,20.56,54.764,23.314c1.246,0.226,2.217,1.201,2.401,2.454 l9.244,62.952c0.165,1.126,0.964,2.054,2.056,2.377c3.512,1.038,11.471,2.367,17.632-4.216c0.563-0.601,0.862-1.404,0.805-2.226 c-0.64-9.287-4.874-69.304-7.923-77.175c-3.103-8.014-46.447-16.441-51.728-17.44c-0.348-0.066-0.703-0.067-1.052-0.005 l-25.333,4.515C118.505,321.263,117.925,324.917,120.367,326.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556BFF"
    },
    d: "M101.763,330.279c0.06,0.016-10.387,19.696,41.937,24.321c1.154,0.102,2.012,1.119,2.13,2.272 l6.503,63.507c0.103,1.006,0.781,1.852,1.739,2.176c3.274,1.104,11.08,2.751,18.098-3.298c0.619-0.534,0.986-1.299,0.964-2.116 c-0.255-9.276-2.007-69.453-4.728-77.446c-2.618-7.69-41.152-17.235-49.779-19.283c-1.031-0.245-2.098,0.169-2.701,1.04 L101.763,330.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3B6295",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M155.047,418.851"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3B6295",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M140.368,355.245"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFEFC"
    },
    d: "M99.341,249.647c16.333-4.859,36.125-0.641,39.368,0.331c3.701,1.11,8.327,5.551,13.323,15.544 c4.996,9.993,4.996,9.993,4.996,9.993l-9.992,2.961v38.119l0,0c-8.921,7.578-19.653,12.716-31.15,14.912l-13.499,2.415 c-1.309,0.234-2.5-0.798-2.455-2.127l1.546-48.504l-16.957,0.893C84.521,284.184,83.734,254.291,99.341,249.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7C2A0"
    },
    d: "M133.118,284.871l-30.446,8.373l-1.194-9.953l-14.152,0.638c0,0-3.189,24.59,5.226,25.116 c12.744,0.796,45.585-15.336,45.585-15.336L133.118,284.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7C2A0"
    },
    d: "M128.231,208.201c1.706-0.688,4.182-0.138,5.44,1.165c3.454,3.578,7.76,9.83,6.3,17.814 c-1.688,9.232-3.877,14.979-8.966,14.884c-1.652-0.031-2.372,1.279-2.425,2.829l-0.314,4.826l0,0 c-1.504,8.441-13.852,9.662-17.384,1.718l-0.579-1.302c-0.424-0.953-0.408-2.039,0.041-2.981 c1.488-3.119,5.111-8.428,1.053-20.204c-0.278-0.806-1.516-3.561-0.727-5.499c0.673-1.654,2.823-1.898,4.19-0.749 c0.301,0.253,0.709,0.299,1.473-0.233C118.979,218.629,119.212,211.839,128.231,208.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE001D"
    },
    d: "M129.329,207.96c0,0,0.143,3.113,5.326,5.785c6.339,3.268,2.439,7.18,5.371,11.805 c3.088,4.871,0.406-4.409,0.406-4.409l-0.899-10.586c-1.79-6.869-4.417-11.36-11.007-9.985c-3.535,0.738-6.953,2.069-8.788,4.442 c-4.833,6.252-5.89,20.495-5.89,20.495s5.312,0.105,8.105-6.569C125.113,211.392,124.742,210.178,129.329,207.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M159.453,293.416h-12.122c-0.995,0-1.802-0.807-1.802-1.802v-26.298 c0-0.995,0.807-1.802,1.802-1.802h12.122c0.995,0,1.802,0.807,1.802,1.802v26.298 C161.255,292.609,160.448,293.416,159.453,293.416z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7C2A0"
    },
    d: "M169.904,283.537L169.904,283.537c-3.29-4.592-7.884-13.221-9.447-13.398 c-0.839-0.095-1.112,0.643-0.741,2.386c1.104,5.18,2.888,6.192-1.961,5.36c-0.7-0.12-4.257-0.813-6.205-1.194 c-1.432-0.28-2.687,1.146-2.106,2.485c0.158,0.364,0.417,0.761,0.812,1.19c0,0-1.146,3.225,1.921,4.026 c0,0,0.36,3.664,2.666,3.828c0,0,2.455,1.527,7.623,3.664l0,0c2.351,1.571,5.509,1.108,7.311-1.071l0.394-0.477 C171.827,288.332,171.712,285.404,169.904,283.537z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18884",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M150.793,280.404 c1.699,0.533,4.306,1.332,5.93,1.255"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18884",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M152.588,284.459 c0,0,3.001,1.15,5.14,0.989"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7C2A0"
    },
    d: "M133.118,284.871l3.696-2.679c2.667-5.311,7.581-14.931,8.473-14.466 c0.982,0.511,1.243,1.586,0.579,3.695c-1.591,5.052-0.807,7.529,2.059,7.312c0.986-0.074,9.457-0.125,9.457-0.125 s2.028,1.814-0.668,3.868c0,0,0.57,3.375-2.59,3.632c0,0-0.99,3.546-3.29,3.308c0,0-2.683,1.078-8.143,2.287l-4.556,2.006 L133.118,284.871z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18884",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M156.179,282.42 c-1.765,0.23-4.472,0.565-6.057,0.208"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18884",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M153.708,286.103 c0,0-3.155,0.612-5.233,0.083"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18884",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M145.287,267.725 c0.982,0.511,1.243,1.586,0.579,3.695c-1.591,5.052-0.807,7.529,2.059,7.312c0.986-0.074,9.457-0.125,9.457-0.125 s2.028,1.814-0.668,3.868c0,0,0.57,3.375-2.59,3.632c0,0-0.99,3.546-3.29,3.308c0,0-2.683,1.078-8.143,2.287"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18884",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M154.844,288.22 c1.202,0.591,5.627,2.839,7.623,3.664l0,0"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M204.718,421.894c0,0-3.576,2.896-13.668,1.348c0,0-0.712,6.315-3.459,9.616 c-2.748,3.301,5.215,7.289,11.188,5.438c5.974-1.851,10.435,2.555,16.339,1.838c5.905-0.717,14.421-7.141,11.263-9.057 c-3.157-1.916-14.379-1.843-17.175-6.229C207.558,422.262,204.718,421.894,204.718,421.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M212.247,437.678 c5.411,1.608,11.455-4.672,11.455-4.672"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M190.049,433.908 c0,0,2.148,2.564,7.084,2.056c4.937-0.507,9.702,0.106,15.113,1.714"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C004F"
    },
    d: "M170.515,426.472c0,0-5.624,3.999-15.613,1.889c0,0,0.135,6.008-2.793,9.15 c-2.928,3.142,4.799,7.57,10.867,6.055c6.068-1.515,10.276,3.134,16.211,2.748c5.935-0.386,14.797-6.324,11.752-8.413 c-3.045-2.089-15.36-3.488-17.907-8.024C171.53,427.203,170.515,426.472,170.515,426.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M176.457,443.702 c5.312,1.908,11.698-4.024,11.698-4.024"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M154.505,438.697 c0,0,2.001,2.68,6.958,2.449c4.957-0.231,9.681,0.648,14.994,2.556"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M170.072,351.624 c-0.503-5.799-1.06-10.152-1.665-11.929c-1.502-4.411-14.82-9.432-27.533-13.299"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M169.719,382.908 c-0.386-9.09-0.863-18.655-1.421-26.724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M159.171,421.3 c3.295-0.166,7.1-1.244,10.698-4.345c0.619-0.534,0.986-1.299,0.964-2.116c-0.082-2.992-0.32-11.278-0.696-21.401"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M146.566,316.262"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M155.399,339.3c0,0,0.327,8.349,9.986,11.295"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M188.466,332.261c0,0,1.964,7.694,10.149,11.95 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M190.661,414.197c0,0,7.626,0.239,13.847-4.508 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M108.404,251.206 c0,0,1.719,10.013,14.563,7.401"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M129.719,251.908 c0,0,0.112,2.79-3.571,5.022"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 86.865,
    y1: 281.798,
    x2: 97.487,
    y2: 281.706
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 101.572,
    y1: 283.086,
    x2: 102.688,
    y2: 275.98
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M117.712,326.822 c-4.061,1.098-8.615,2.02-13.666,2.623"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M143.128,314.528 c0,0-6.119,5.621-18.555,10.131"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M126.864,318.601 c-2.687,1.019-5.494,1.72-8.236,1.81"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#315782",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M142.979,308.711 c0,0-4.658,4.134-10.903,7.49"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M119.549,333.734c0,0,3.438,7.366-2.292,12.768 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetbanking);
export default __webpack_public_path__ + "static/media/netbanking.6d645bf1293fe3221d346d025e205cde.svg";
export { ForwardRef as ReactComponent };